const normalizeTwig = token => token.replace(/\s+/g, '').replaceAll('"', '\'');

const readExpressionHead = token => normalizeTwig(token).slice(2, -2).split('(')[0];

const findTwigTokens = filename => [...filename.matchAll(/\{\{.*?\}\}/g)];

const splitExtension = filename => {
    const match = filename.match(/^(.*?)(\.[A-Za-z0-9]{1,5})$/s);

    return match === null ? [filename, ''] : [match[1], match[2]];
};

const addPart = (filename, snippet) => {
    const [name, extension] = splitExtension(filename);
    const separator         = name === '' || /[-_ ]$/.test(name) ? '' : '-';

    return name + separator + snippet + extension;
};

const removePart = (filename, token) => {
    let start = token.index;
    let end   = token.index + token[0].length;

    if (/[-_ ]/.test(filename[start - 1] ?? '')) {
        start--;
    } else if (/[-_ ]/.test(filename[end] ?? '')) {
        end++;
    }

    const remaining         = filename.slice(0, start) + filename.slice(end);
    const [name, extension] = splitExtension(remaining);

    return name.trim() === '' ? `export${extension}` : remaining;
};

const togglePart = (filename, snippet) => {
    const tokens  = findTwigTokens(filename);
    const current = tokens.find(token => normalizeTwig(token[0]) === normalizeTwig(snippet));

    if (current) {
        return removePart(filename, current);
    }

    const rival = tokens.find(token => readExpressionHead(token[0]) === readExpressionHead(snippet));

    if (rival) {
        return filename.slice(0, rival.index) + snippet + filename.slice(rival.index + rival[0].length);
    }

    return addPart(filename, snippet);
};

const containsPart = (filename, snippet) => findTwigTokens(filename)
    .some(token => normalizeTwig(token[0]) === normalizeTwig(snippet));

const selectFirstSequence = form => {
    const sequenceSelect = form.elements.namedItem('sequence');

    if (sequenceSelect.value !== '') {
        return;
    }

    const firstSequence = [...sequenceSelect.options].find(option => option.value !== '');

    sequenceSelect.closest('od-select').selectValue(firstSequence.value);
    sequenceSelect.dispatchEvent(new Event('change', {bubbles: true}));
};

const markActiveParts = form => {
    const filenameInput = form.querySelector('[name="filenamePattern"]');

    form.querySelectorAll('[data-export-filename-part]').forEach(partButton => {
        const isActive = containsPart(filenameInput.value, partButton.dataset.exportFilenamePart);

        partButton.classList.toggle('is-active', isActive);
        partButton.setAttribute('aria-pressed', String(isActive));
    });
};

export const initializeFilenameParts = root => {
    root.querySelectorAll('[data-export-filename-parts]').forEach(parts => markActiveParts(parts.closest('form')));
};

export const syncFilenamePatternValidity = root => {
    if (!root.matches?.('[data-export-next-file]')) {
        return;
    }

    root.closest('form').querySelector('[name="filenamePattern"]')
        .classList.toggle('is-invalid', root.querySelector('.invalid-feedback') !== null);
};

export const handleFilenamePatternInput = event => {
    if (event.target.name !== 'filenamePattern' || !event.target.form) {
        return;
    }

    markActiveParts(event.target.form);
};

export const handleFilenamePartClick = event => {
    const partButton = event.target.closest('[data-export-filename-part]');

    if (!partButton) {
        return false;
    }

    const form          = partButton.closest('form');
    const filenameInput = form.querySelector('[name="filenamePattern"]');
    const snippet       = partButton.dataset.exportFilenamePart;

    filenameInput.value = togglePart(filenameInput.value, snippet);

    if (partButton.hasAttribute('data-export-filename-sequence') && containsPart(filenameInput.value, snippet)) {
        selectFirstSequence(form);
    }

    filenameInput.dispatchEvent(new Event('input', {bubbles: true}));
    filenameInput.focus();

    return true;
};
